import React from 'react';
import Header from '../componentes/Header';
import { NavLink, Link, useNavigate } from 'react-router';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion } from 'framer-motion';
import telasPremiumVeritlux from '../data/todosLosProductos/telasPremiumVertilux';

import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import WhatsAppContact from '../componentes/WhastsAppContact';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const PaginaVertilux = () => {
        const navigate = useNavigate();
    return ( 
        <>
        <Helmet>
            <title>Telas Premium Vertilux | Hi Blinds</title>
            <meta name="description" content="Tecnología textil avanzada con la línea Vertilux. Telas de alto rendimiento para persianas modernas." />
            <meta property="og:title" content="Telas Premium Vertilux | Hi Blinds" />
            <meta property="og:description" content="La revolución en telas para persianas. Alta calidad y diseño exclusivo con Vertilux." />
            <meta property="og:url" content="https://hiblindsmx.com/telas-premium-vertilux" />
        </Helmet>
            <Header />
            <AnimacionPagina>
                <SectionProductos>

                <h1>Telas prémium Vertilux</h1>
                <BtnVolverAnim Ref='/'/>
                <ContainerProductos>
                    {telasPremiumVeritlux.map((producto, index) =>  {
                     const { imagenDemostracion } = procesarProducto(producto);

                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer 
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                            key={producto.id}
                            onClick={() => {
                            navigate(`/telas-premium-vertilux/${producto.slug}`);
                                }}
                            style={{ cursor: 'pointer' }}>
                                <img 
                                loading='lazy' 
                                src={imagenDemostracion} 
                                alt={`${producto.nombre}`} 
                                />
                                <h4>{producto.nombre}</h4>
                                <p>Ancho de rollo: <br/> {producto.anchoRollo}</p>
                                <Link to={`/telas-premium-vertilux/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
                <WhatsAppContact 
                    phoneNumber="524773059542" 
                    defaultMessage="Quiero saber sobre otros modelos de Vertilux" 
                />
                <WhatsAppShareButton message="¡Revisa nuestras telas prémium Vertilux!" />
                <BtnVolverAnim Ref='/'/>
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
            
        </>
     );
}
const procesarProducto = (producto) => {
    const imagenDemostracion = producto.images[0];
    const imagenesColores = producto.images.slice(1).map((imagen, index) => ({
        color: producto.colores[index],
        imagen
    }));
    return { imagenDemostracion, imagenesColores };
};




export default PaginaVertilux;